<!-- 导入弹框 -->
<template>
  <div class="batch-import">
    <e-dialog
      popup-width="600px"
      dialog-title="导入"
      :center-dialog-visible="importVisible"
      sub-btn="确认导入"
      @resetPopupData="resetPopupData"
      @submitPopupData="importSubmitPopupData('ruleForm')"
    >
      <el-form ref="uploadForm" size="small">
        <el-form-item label="下载模版:" label-width="100px" prop="">
          <el-button type="text" class="download-text" @click="downPurchaseTemplate">下载导入模板</el-button>
        </el-form-item>
        <el-form-item label="上传模板:" label-width="100px">
          <eui-upload
            ref="upload"
            :data="data"
            :file-list="fileArr"
            :action="url"
            :auto-upload="autoUpload"
            :headers="headers"
            :show-file-list="true"
            :limit="1"
            accept=".xlsx,.xls,"
            text="选择上传"
            tip="格式支持Excel"
            @handleSuccess="uploadSuccess"
          ></eui-upload>
        </el-form-item>
        <div style="margin-left: 30px">
          说明：单次导入最多1000个商品
          <!-- ,
          <span style="color: #ef4c56">集采价不能高于易资源惠享价</span> -->
        </div>
      </el-form>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import { epecToken } from '@/modules/projectA/utils/globalData';
import utils from '@/modules/projectA/utils/utils';
import api from '@/modules/projectA/api/agreement';

export default {
  components: { eDialog },
  props: {
    importVisible: Boolean,
  },
  data() {
    return {
      autoUpload: false,
      fileList: [],
      fileArr: [],
      uploadLoading: false,
      headers: epecToken,
      downloadUrl: '',
      privateUpload: {},
      data: {
        agreementId: this.$route.query.agreementId,
      },
      url: api.importChangePriceAgreement,
    };
  },
  methods: {
    importSubmitPopupData() {
      this.$refs.upload.submit();
    },
    uploadSuccess(res) {
      if (res.success) {
        this.$message.success('文件上传成功。');
        this.$emit('refresh');
        this.$emit('update:importVisible', false);
      } else {
        this.$message.warning(res.message);
      }
    },
    async downPurchaseTemplate() {
      const res = await api.downPriceTemplate();
      utils.downFile(res, '导入商品调价模板');
    },
    // 关闭弹窗
    resetPopupData() {
      this.$emit('update:importVisible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.batch-import {
  .download-text {
    text-decoration: underline;
    color: #0064c8;
    font-size: 14px;
    cursor: pointer;
  }
  .hint {
    margin-left: 30px;
    word-wrap: break-word;
    color: #666666;
    font-size: 14px;
    line-height: 1.3;
  }
  .upload-file {
    position: relative;
    .error {
      position: absolute;
      left: 0;
      top: 28px;
      color: red;
      font-size: 12px;
    }
    ::v-deep .el-button {
      border-radius: 0;
      min-width: 80px;
      height: 30px;
    }
  }
  ::v-deep.el-dialog__body {
    padding: 10px;
  }
  ::v-deep.el-dialog__header {
    background: #f5f5f5;
    height: 40px;
    padding: 0 20px;
    line-height: 40px;
    .el-dialog__headerbtn {
      top: 8px;
    }
    .el-dialog__title {
      font-size: 14px;
    }
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    .el-button {
      border-radius: 0;
      min-width: 80px;
      height: 30px;
    }
  }
}
</style>
